import { useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom"; // Added useNavigate
import { loginUser } from "../features/cred/credSlice";

// 1. Import react-toastify
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; // Import the CSS

const SignComponent = ({ signin = true }) => {
  const [email, setEmail] = useState("");
  const [userName, setUserName] = useState(""); // Only used if !signin
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate(); // For imperative navigation

  const loggedIn = async () => {
    try {
      // Dispatch returns the action object itself, or a promise if it's an async thunk
      // The actual payload is usually inside action.payload after the thunk resolves
      setLoading(true); // Set loading state to true
      const actionResult = await dispatch(loginUser({ email, password }));
      // Check if the thunk was fulfilled and the payload indicates success
      if (loginUser.fulfilled.match(actionResult)) {
        // Access the actual response data from the backend via actionResult.payload
        const responsePayload = actionResult.payload;

        // Adjust this condition based on your actual backend response structure
        if (responsePayload?.status === 200 || responsePayload?.success === true || responsePayload?.token) {
          toast.success("Logged in successfully!", {
            // onClose: () => navigate("/announcement", { replace: true }), // Navigate when toast closes
            onClose: () => navigate("/dashboard", { replace: true }), // Navigate when toast closes
            // onClose: () => navigate("/", { replace: true }), // Navigate when toast closes
            autoClose: 1500, // Optional: Set a shorter autoClose for the success toast if desired
          });
        
        } else {
          // If the backend call was successful (e.g., 200 OK) but login failed logically
          const errorMessage = responsePayload?.message || "Invalid credentials or unknown error.";
          toast.error(errorMessage);
          setLoading(false); // Reset loading state
        }
      } else if (loginUser.rejected.match(actionResult)) {
        // Handle rejected thunk (e.g., network error, or error thrown in thunk)
        const errorMessage = actionResult.payload?.message || actionResult.error?.message || "Login failed. Please try again.";
        console.error("Login rejected:", actionResult);
        toast.error(errorMessage);
        setLoading(false); // Reset loading state
      }
    } catch (error) {
      // Catch any unexpected errors during the dispatch process
      console.error("Unexpected error during login:", error);
      toast.error("An unexpected error occurred during login.");
      setLoading(false); // Reset loading state
    }
  };

  const handleLogin = (e) => {
    e.preventDefault();
    console.log("Attempting to log in with", email, password);
    loggedIn();
  };

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={5000} // Auto close after 5 seconds
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <div className='d-flex align-items-center justify-content-center min-vh-100 bg-base px-4'>
        <div className='card radius-12 shadow-lg p-32 w-100' style={{ maxWidth: "420px" }}>
          <div className='text-center mb-24'>
            <h3 className='text-2xl fw-bold mb-8'>{signin ? `Welcome Back` : `Create an Account`}</h3>
            <p className='text-sm text-secondary-light'>{signin ? `Please sign in to your account` : `Please fill in the details to create an account`}</p>
          </div>

          <form onSubmit={handleLogin} className='d-flex flex-column gap-16'>
            <div className='form-group'>
              <label className='text-sm text-secondary mb-6' htmlFor="email-input">Email Address</label>
              <input
                type='email'
                id="email-input"
                className='form-control form-control-sm radius-8 h-40-px'
                placeholder='you@example.com'
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoFocus
              />
            </div>

            {!signin && (
              <div className='form-group'>
                <label className='text-sm text-secondary mb-6' htmlFor="username-input">Username</label>
                <input
                  type='text'
                  id="username-input"
                  className='form-control form-control-sm radius-8 h-40-px'
                  placeholder='example_username'
                  value={userName}
                  onChange={(e) => setUserName(e.target.value)}
                  required
                />
              </div>
            )}

            <div className='form-group'>
              <label className='text-sm text-secondary mb-6' htmlFor="password-input">Password</label>
              <input
                type='password'
                id="password-input"
                className='form-control form-control-sm radius-8 h-40-px'
                placeholder='********'
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>

            {signin && (
              <div className='d-flex justify-content-between align-items-center mt-8'>
                <div className='form-check'>
                  <input type='checkbox' className='form-check-input' id='rememberMe' />
                  <label className='form-check-label text-sm text-secondary-light' htmlFor='rememberMe'>
                    Remember Me
                  </label>
                </div>
                {/* <Link to='/forgot-password' */}
                <Link to='/'
                      className='text-sm text-black fw-medium'>
                  Forgot Password?
                </Link>
              </div>
            )}

            <button
              type='submit'
              className='btn btn-bg mt-16 text-sm fw-medium d-flex align-items-center justify-content-center gap-8'
              disabled={loading}
            >
              {loading ? (
                <>
                  <span className='loader-sm'></span>
                  {signin ? 'Signing In...' : 'Signing Up...'}
                </>
              ) : (
                signin ? 'Sign In' : 'Sign Up'
              )}
            </button>

          </form>

          <div className='text-center mt-24'>
            <span className='text-sm text-secondary-light'>
              {signin ? `Don't have an account?` : `Already have an account?`}
            </span>
             
            <Link to={signin ? '/signin' : '/login'} // Adjust routes as needed
                  className='text-sm text-black fw-medium'>
              Create an account from Super Admin
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default SignComponent;